<p-toast></p-toast>
<p-progressBar *ngIf="loading"
  mode="indeterminate"
  [style]="{
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '6px',
    zIndex: '9999'
  }">
</p-progressBar>

<div class="grupo-al">
  <div class="p-fluid p-grid">
    <div class="p-col-12"
      style="display: flex; align-items: center">
      <img src="favicon.ico"
        alt=""
        style="width: 24px; margin-right: 10px" />
      <h3 style="font-size: 24px; font-weight: bold">Licenças</h3>
    </div>
    <div class="p-col-12 p-grid"
      style="align-items: flex-start">
      <div class="p-col">
        <habil-label name="searchClass"
          label="Busca">
          <input pInputText
            class="search-lista"
            [(ngModel)]="search"
            name="pesquisa"
            class="p-inputtext-lg"
            autocomplete="off"
            (keydown.enter)="buscarDadosLicenca()"
            placeholder="Digite o CPF/CNPJ para pesquisa..."
            [readonly]="false"
            style="max-height: 36px" />
        </habil-label>
      </div>
      <div class="p-col-fixed"
        style="align-items: flex-end; height: 100%; display: flex;">
        <button pButton
          label="Buscar"
          icon="pi pi-search"
          (click)="buscarDadosLicenca()"></button>
      </div>
    </div>
    <div class="p-col-12">
      <hr>
    </div>
    <div class="p-col-12" *ngIf="!loading">
      <h3>{{(registro?.nome || '')}}</h3>
      <h3>{{(registro?.cnpj || '')}}</h3>
      <h5><b>{{(registro?.classificacao?.descricao || '')}}</b></h5>
      <br>
      <p-accordion *ngIf="registro?.licencas"
        [multiple]="true">
        <p-accordionTab *ngFor="let lic of licenca; let i = index"
          [header]="getSoftware(lic.licenca?.software)"
          [selected]="true">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12">
              <habil-label name="lbVencimento"
                label="Vencimento">
                <h4 style="margin: 0;"> {{vencimento(lic) | date: 'dd/MM/yyy'}}</h4>
                <!-- <habil-date-edit *ngIf="lic?.registroLicenca?.expDate"
                  [ngModel]="lic.registroLicenca.expDate"></habil-date-edit>
                <habil-date-edit *ngIf="lic?.registroLicenca?.val"
                  [ngModel]="lic.registroLicenca.expDate"></habil-date-edit> -->
              </habil-label>
            </div>
            <div class="p-field p-col-fixed">
              <button pButton
                [disabled]="lic?.oldTrial > 0 || isMaiorQue5Dias(lic?.registroLicenca) || lic?.registroLicenca?.trial == 3"
                (click)="addTrial(lic.registroLicenca, 3)"> <b>+3</b> </button>
            </div>
            <div class="p-field p-col-fixed">
              <button pButton
                [disabled]="lic?.oldTrial > 0 || isMaiorQue5Dias(lic?.registroLicenca) || lic?.registroLicenca?.trial == 5"
                (click)="addTrial(lic.registroLicenca, 5)"> <b>+5</b> </button>
            </div>
            <div class="p-field p-col-fixed">
              <button pButton
                label="Salvar"
                class="p-button-success"
                icon="pi pi-check"
                (click)="salvar(lic)"></button>
            </div>
            <!-- <div class="p-field p-col-12"
              *ngIf="lic?.registroLicenca?.emissoes">
              <p-panel header="Emissões">
                <p-table [value]="lic.registroLicenca.emissoes"
                  [scrollable]="true"
                  style="width: 100%">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 25%">CNPJ</th>
                      <th style="width: 6.25%">NF-e</th>
                      <th style="width: 6.25%">Vencimento</th>
                      <th style="width: 6.25%">Qtde</th>
                      <th style="width: 6.25%">NFC-e</th>
                      <th style="width: 6.25%">Vencimento</th>
                      <th style="width: 6.25%">Qtde</th>
                      <th style="width: 6.25%">NFS-e</th>
                      <th style="width: 6.25%">Vencimento</th>
                      <th style="width: 6.25%">Qtde</th>
                      <th style="width: 6.25%">SAT</th>
                      <th style="width: 6.25%">Vencimento</th>
                      <th style="width: 6.25%">Qtde</th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body"
                    let-product>
                    <tr>
                      <td style="width: 25%">{{ product.documento }}</td>
                      <td style="width: 6.25%">
                        {{ product.nfe ? "Sim" : "Não" }}
                      </td>
                      <td style="width: 6.25%">
                        {{ product.vctoNfe | date : "dd/MM/yyyy" }}
                      </td>
                      <td style="width: 6.25%">{{ product.qtdeDocsNfe }}</td>
                      <td style="width: 6.25%">
                        {{ product.nfce ? "Sim" : "Não" }}
                      </td>
                      <td style="width: 6.25%">
                        {{ product.vctoNfce | date : "dd/MM/yyyy" }}
                      </td>
                      <td style="width: 6.25%">{{ product.qtdeDocsNfce }}</td>
                      <td style="width: 6.25%">
                        {{ product.nfs ? "Sim" : "Não" }}
                      </td>
                      <td style="width: 6.25%">
                        {{ product.vctoNfs | date : "dd/MM/yyyy" }}
                      </td>
                      <td style="width: 6.25%">{{ product.qtdeDocsNfs }}</td>
                      <td style="width: 6.25%">
                        {{ product.sat ? "Sim" : "Não" }}
                      </td>
                      <td style="width: 6.25%">
                        {{ product.vctoSat | date : "dd/MM/yyyy" }}
                      </td>
                      <td style="width: 6.25%">{{ product.qtdeDocsSat }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </p-panel>
            </div> -->
            <!-- <div class="p-field p-col-12"
              *ngIf="lic?.licenca?.modulosLicenciados">
              <p-panel header="Produtos liberados">
                <ng-container *ngFor="let mod of lic?.licenca?.modulosLicenciados">
                  <p>{{mod.descricaoModulo}}</p>
                </ng-container>
              </p-panel>
            </div> -->
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>

</div>